<template>
    <div>
        <div class="actions" v-if="type !== 'edit'">
            <b-button variant="success" @click="openModal(true, 'add', customer )">  <b-icon icon="plus" /> {{$t('general.add')}}</b-button>
        </div>
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

        <b-table-simple v-else hover responsive>
            <b-thead>
                <b-th> {{$t('customer.remoteUsers.username')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.name')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.lastname')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.phone')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.email')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.status')}} </b-th>
                <b-th> {{$t('customer.remoteUsers.actions')}} </b-th>
            </b-thead>
            <b-tbody>
            <b-tr v-for="ru in remoteUsers" :key="ru.id">
                    <b-td> {{ru.username}} </b-td>
                    <b-td> {{ru.firstname}} </b-td>
                    <b-td> {{ru.lastname}} </b-td>
                    <b-td> {{ru.phoneno}} </b-td>
                    <b-td> {{ru.email}} </b-td>

                    <b-td> 
                        <div v-if="ru.active == true" > <b-icon icon="check" variant="success"></b-icon> <b-badge variant="success" > Aktif </b-badge> </div>
                        <div v-else >  <b-icon icon="x" variant="danger" animation="throb"></b-icon>  <b-badge variant="danger" > Pasif </b-badge> </div>            
                    </b-td>
                    <b-td> 
                        <b-dropdown variant="default">
                            <template slot="button-content"> <b-icon :title="field.label" icon="three-dots"  scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>
                            <b-dropdown-item 
                                v-for="action in actions"
                                :key="action.key"
                                @click="actionEvent(action.key, item )"
                                :disabled="action.state == item['active'] || action.state == item['is_active']"> 
                                {{action.text}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>

                </b-tr>
            </b-tbody>
        </b-table-simple>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" form="RemoteUser" :modalName="modalName" />

    </div>
</template>

<script>
    import moment from 'moment'
    import Modals from '../modals'

    export default {
        name: "RemoteUser",
        props:{
            customer: Object || String,
            type: String,
        },
        data: function(){
            return{
                modalName: "",
                modalProps: {},
                modalOpen: false
            }
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY');
            },
        },
        components: {
            Modals
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            remoteUsers(){
                return []
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>
<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/RemoteUser.vue